<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <!-- Your content for Tab 1 goes here -->
    <p>Client for Tab 90 Days</p>
    <b-row>
      <b-col md="8" class="my-1">
        <h5>
          <small>Client Not Used</small>
        </h5>
      </b-col>
      <b-col md="2"
        ><h5>
          <small v-if="isLoading == false">{{ totalData }} Entries</small>
        </h5>
      </b-col>
      <b-col md="6">
        <b-form-input
          :formatter="capitalizeAll"
          placeholder="Client Filter"
          id="clientNameFilter"
          name="clientNameFilter"
          v-model="Filter.clientNameFilter"
          @input="getNinghtyDaysPendingClientJobListFunc('Normal', '0', '0', '1', '1')"
        ></b-form-input
      ></b-col>
      <b-col md="4">
        <model-list-select
          class="ml-1"
          :list="$store.getters['common/getAllBranchList']"
          id="branchfilter"
          v-model="Filter.branchfilter"
          option-value="pickupId"
          option-text="pickupLocation"
          placeholder="All Branch"
          @input="getNinghtyDaysPendingClientJobListFunc('Normal', '0', '0', '1', '1')"
          :isDisabled="
            $sessionsStorage.get('designation') != 'Admin' &&
            $sessionsStorage.get('nameUser') != 'Bhavneesh'
              ? true
              : false
          "
        ></model-list-select>
      </b-col>
      <b-col md="2">
        <b-button
          class="pull-right mb-1"
          v-if="getNinghtyDaysPendingClientJobList.length > 0"
          :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
          @click="getReports('getNinghtyDaysPendingClientJobList', 'Export As Excel')"
          size="sm"
          variant="warning"
          style="font-size: 0.675rem"
        >
          {{ ExcelBtnName }}
          <b-spinner
            v-if="ExcelBtnName != 'Export As Excel'"
            small
            label="Small Spinner"
          ></b-spinner
        ></b-button>
      </b-col>
    </b-row>
    <div class="row">
      <div class="col-md-12">
        <div class="table-responsive tableMain gutr">
          <!-- <b-table
            show-empty
            stacked="md"
            :items="getNinghtyDaysPendingClientJobList"
            responsive
            :fields="ninghtyDayField"
            primary-key="clientId"
            :per-page="pagination.perPage"
            :current-page="pagination.currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            class="position-relative"
          > -->
          <b-table
          responsive
            :items="getNinghtyDaysPendingClientJobList"
            :fields="ninghtyDayField"
            primary-key="clientId"
            class="position-relative"
          >
            <template slot="SN" slot-scope="row0">
              <span>{{
                row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
              }}</span>
            </template>
            <template slot="clientName" slot-scope="row1">
              <span>Client Type : {{ row1.item.clientType }}<br /></span>
              <span>Client Name : {{ row1.item.clientName }}<br /></span>
            </template>
            <template slot="clientSeries" slot-scope="row3">
              <span>{{ row3.item.clientSeries }}<br /></span>
            </template>
            <template slot="lastAssignmentNumber" slot-scope="row4">
              <span>Last Job No : {{ row4.item.lastAssignmentNumber }}<br /></span>
              <span>Last Job Date : {{ row4.item.lastAssignmentDate }}<br /></span>
            </template>
            <template slot="clientId" slot-scope="row2">
              <JobHistory
                v-if="row2.item.clientId"
                :PMC_title="'Last 10 Job History Client - ' + row2.item.clientName"
                :PMC_ClientID="row2.item.clientId"
                :PMC_ClientName="row2.item.clientName"
                :PMC_ClientEmail="row2.item.email"
                :PMC_ClientPhone="row2.item.phoneKYC"
                :PMC_ClientSeries="row2.item.clientSeries"
                :PMC_Filter="Filter"
              />
              <AddClientMOM
                v-if="row2.item.clientId"
                :PMC_title="'Add Client MOM - ' + row2.item.clientName"
                :PMC_ClientID="row2.item.clientId"
                :PMC_ClientName="row2.item.clientName"
                :PMC_ClientEmail="row2.item.email"
                :PMC_ClientPhone="row2.item.phoneKYC"
                :PMC_ClientSeries="row2.item.clientSeries"
                :PMC_Filter="Filter"
                :PMC_mom_id="0"
                :PMC_mom_Data="{}"
              />
              <ViewClientMOM
                v-if="row2.item.clientId"
                :PMC_title="'View Client MOM - ' + row2.item.clientName"
                :PMC_ClientID="row2.item.clientId"
                :PMC_ClientName="row2.item.clientName"
                :PMC_ClientEmail="row2.item.email"
                :PMC_ClientPhone="row2.item.phoneKYC"
                :PMC_ClientSeries="row2.item.clientSeries"
                :PMC_Filter="Filter"
              />
            </template>
          </b-table>
        </div>
        <div>
          <b-pagination
            limit="8"
            align="center"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total-rows="totalData"
            @change="onPageChange($event)"
          ></b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import {
  lastVisitPage,
  globalPermissionStatus,
  GlobalGetLocation,
} from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import CommonService from "../../services/CommonService.js";
import JobHistory from "../common/moduleBasedClientJobs.vue";
import AddClientMOM from "./clientMOM.vue";
import ViewClientMOM from "./viewClientMOM.vue";
export default {
  // Component logic for Tab 1
  beforeMount() {
    this.$store.dispatch(
      "common/setAllBranchList",
      JSON.stringify({
        filter: "BranchList",
        active: "all",
      })
    );
    this.$store.dispatch(
      "common/setAllClientList",
      JSON.stringify({
        itemCode: "ClientList",
      })
    );
    lastVisitPage(this.$router.history.current.fullPath);
    if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
      this.fetchLastPage(this.lastVisitPage);
    } else {
      this.getNinghtyDaysPendingClientJobListFunc("Normal", "0", "0", "1", "1");
    }
    // this.getNinghtyDaysPendingClientJobListFunc("Normal", "0", "0", "1", "1");
  },
  mounted() {},
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},
  data() {
    return {
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      ExcelBtnName: "Export As Excel",
      getNinghtyDaysPendingClientJobList: [],
      totalData: 0,
      ninghtyDayField: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "clientName",
          mainkey: "clientName",
          label: "Client",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "clientSeries",
          mainkey: "clientSeries",
          label: "Client Series",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "operatingBranch",
          mainkey: "operatingBranch",
          label: "Operating Branch",
          sortable: true,
          sortDirection: "ASC",
          table: "E.",
        },
        {
          key: "lastAssignmentNumber",
          mainkey: "lastAssignmentNumber",
          label: "Last Job Det.",
          sortable: true,
          sortDirection: "ASC",
          table: "F.",
        },
        {
          key: "clientId",
          mainkey: "clientId",
          label: "Action",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
      ],
      pagination: {
        currentPage: 1,
        perPage: 25,
        pageOptions: [5, 10, 15],
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,

      docURL: URL_BASE_DOC,
      Filter: {
        pendingClient: "All",
        clientNameFilter: "",
        clientIdFilter: "",
        branchFilter: "",
        transportTypeFilter: "",
        shipmentTypeFilter: "",
        jobTypeFilter: "",
      },
      isLoading: false,
    };
  },
  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,
    JobHistory,
    AddClientMOM,
    ViewClientMOM,
  },
  computed: {},
  watch: {
    JOBSERIES: {
      handler: function (newVal, oldVal) {
        this.getData();
      },
      deep: true,
    },
  },
  methods: {
    getNinghtyDaysPendingClientJobListFunc(type, filterIdD, CURRENT, SEARCH, pageNumber) {
      this.getNinghtyDaysPendingClientJobList = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        itemCode: "getNinghtyDaysPendingClientJobList",
        type: type,
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.pagination.perPage,
        activeButtonBranch: this.activeButtonBranch,
        Filter: this.Filter,
      };

      CommonService.getAllJobList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log();
          if (status == 200 && data) {
            if (type == "Excell") {
              if (data.getNinghtyDaysPendingClientJobList.length > 0) {
                this.totalData = data.totalData;
                this.getNinghtyDaysPendingClientJobList =
                  data.getNinghtyDaysPendingClientJobList;
              }
              this.ExcelBtnName = "Export As Excel";
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.getNinghtyDaysPendingClientJobList.length > 0) {
                this.totalData = data.totalData;
                this.getNinghtyDaysPendingClientJobList =
                  data.getNinghtyDaysPendingClientJobList;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getNinghtyDaysPendingClientJobList Error: ", error);
        });
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.pagination.currentPage = 1;
    },
    clearTimeout() {},
    goBack() {
      window.history.go(-1);
    },
    filterClear() {
      this.Filter = {
        pendingClient: "All",
        clientNameFilter: "",
        clientIdFilter: "",
        branchFilter: "",
        transportTypeFilter: "Import",
        shipmentTypeFilter: "",
        jobTypeFilter: "TPT",
      };
      this.getNinghtyDaysPendingClientJobListFunc("Normal", "0", "0", "1", "1");
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getNinghtyDaysPendingClientJobListFunc("Normal", "0", "0", "1", "1");
      }, 1000);
    },
    getReports(id, btnName) {
      this.isLoading = true;
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getNinghtyDaysPendingClientJobListFunc("Excell", "0", "0", "1", "1");
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getNinghtyDaysPendingClientJobListFunc("Normal", "0", CURRENT, "2", event);
      // this.getNinghtyDaysPendingClientJobListFunc("Normal");
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getNinghtyDaysPendingClientJobListFunc("Normal", "0", CURRENT, "2", event);
      // this.getNinghtyDaysPendingClientJobListFunc("Normal");
    },
  },
};
</script>



// WEBPACK FOOTER //
// allClient.vue?24482dec